import { Component, Input } from '@angular/core';
import { LinkRef, Media } from '@kion/data-models';


@Component({
  selector: 'kion-teaser',
  templateUrl: './teaser.component.html',
  styleUrls: ['./teaser.component.scss']
})
export class TeaserComponent {

  @Input() colorSchema: string;
  @Input() title: string;
  @Input() titleSize: string;
  @Input() description: string;
  @Input() image: Media;
  @Input() contentAlignment: 'right' | 'left'| string = 'right';
  @Input() link: LinkRef;
  @Input() fontSize: string
}
